export default "__VITE_ASSET__lfhIa5oO__"